import { Placeholder } from 'modules/common/components/Placeholder';
import { ReferralProgram } from 'modules/strapi/types';

import { PromoGreeting } from './components/PromoGreeting';
import { ReferralGreeting } from './components/ReferralGreeting';
import { useGreetingStyles } from './useGreetingStyles';

export interface IGreetingProps {
  referralProgram: ReferralProgram | undefined;
}

export const Greeting = ({ referralProgram }: IGreetingProps) => {
  const { classes } = useGreetingStyles();

  return (
    <div className={classes.root}>
      <Placeholder
        hasPlaceholder={Boolean(referralProgram)}
        placeholder={<PromoGreeting referralProgram={referralProgram!} />}
      >
        <ReferralGreeting />
      </Placeholder>
    </div>
  );
};
